import React from "react";
import AuthLayout from "./layout/authLayout";
import "./index.css";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Login from "./modules/account/login";
import ForgotPassword from "./modules/account/forgotPassword";
import LinkSent from "./modules/account/linkSent";
import SignUp from "./modules/account/signup";
import NewPassword from "./modules/account/newPassword";
import ResetSuccesful from "./modules/account/resetSuccessful";
import CompleteSignUp from "./modules/account/completeSignUp";
import AppLayout from "./layout/appLayout";
import AuthProvider from "./context/authContext";
import Dashboard from "./modules/dashboard";
import Calls from "./modules/calls";
import Leads from "./modules/leads";
import Projects from "./modules/projects";
import NewProject from "./modules/projects/new";
import KnowledgeBase from "./modules/knowledgebase";
import GlobalModal from "./layout/appLayout/modal";
import Appointments from "./modules/appointments";
import Settings from "./modules/settings";
import ProjectDetails from "./modules/projects/details";
import ThemeProvider from "./context/themeContext";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import Signout from "./modules/account/logout";
import ConnectCalendar from "./modules/projects/connectcalendar";
import PayStackRedirect from "./modules/redirect/paystack";

export default function App() {
  const queryClient = new QueryClient();

  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <Router>
          <AuthProvider>
            <Routes>
              <Route
                index
                path="/account/*"
                element={
                  <>
                    <AuthLayout>
                      <Routes>
                        <Route index path="/login" element={<Login />} />
                        <Route path="/logout" element={<Signout />} />
                        <Route path="/signup" element={<SignUp />} />
                        <Route
                          path="/completesignup"
                          element={<CompleteSignUp />}
                        />
                        <Route
                          path="/forgotpassword"
                          element={<ForgotPassword />}
                        />
                        <Route path="/linksent" element={<LinkSent />} />
                        <Route path="/newpassword" element={<NewPassword />} />
                        <Route
                          path="/resetsuccessful"
                          element={<ResetSuccesful />}
                        />
                        <Route path="*" element={<Navigate to="/login" />} />
                      </Routes>
                    </AuthLayout>
                  </>
                }
              />
              <Route
                path="/*"
                element={
                  <>
                    <AppLayout>
                      <Routes>
                        <Route
                          path="*"
                          element={<Navigate to={"/dashboard"} />}
                        />
                        <Route path="/dashboard" element={<Dashboard />} />
                        <Route path="/calls" element={<Calls />} />
                        <Route path="/contacts" element={<Leads />} />
                        <Route path="/campaigns" element={<Projects />} />
                        <Route
                          path="campaigns/:id"
                          element={<ProjectDetails />}
                        />
                        <Route
                          path="/knowledgebase"
                          element={<KnowledgeBase />}
                        />
                        <Route
                          path="/appointments"
                          element={<Appointments />}
                        />
                        <Route path="/settings" element={<Settings />} />
                      </Routes>
                    </AppLayout>
                  </>
                }
              />
              <Route path="/redirect/paystack" element={<PayStackRedirect />} />
              <Route
                path="/campaigns/new"
                element={
                  <>
                    <GlobalModal />
                    <NewProject />
                  </>
                }
              />
              <Route
                path="/campaigns/edit/:id"
                element={
                  <>
                    <GlobalModal />
                    <NewProject />
                  </>
                }
              />
              <Route
                path="/campaigns/connectcalendar"
                element={<ConnectCalendar />}
              />
            </Routes>
          </AuthProvider>
        </Router>
      </ThemeProvider>
    </QueryClientProvider>
  );
}
